import React from 'react';
import _ from 'lodash';
import themeData from './themes.json'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';

export const BrandMappingBasicInfoComponent = ({ webpages, websites,
  brandMappings, onFormItemBrandChange, accountListLoading, policyOwnerType, accountTypesListLoading, accountTypesList, accountsList, onInnerBasicFormChange
}: any) => {
  //  const entityType: any = [
  //     { Description: 'Website', Value: 3 },
  //     { Description: 'WebPages', Value: 4 },
  //   ]
  return (
    <>
      {_.map(brandMappings, (selectedBrand: any, index: any) => (
        <AccordionContainer
          child={
            <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
              <InputContainer
                label="Name"
                labelField="Name"
                onValueChange={(event: any, newValue: any) => {
                  onFormItemBrandChange({
                    value: event.target.value,
                    field: 'Name',
                    idx: index
                  });
                }}
                type="text"
                value={selectedBrand?.Name} />
              <InputContainer
                label="Description"
                labelField="Description"
                onValueChange={(event: any, newValue: any) => {
                  onFormItemBrandChange({
                    value: event.target.value,
                    field: 'Description',
                    idx: index
                  });
                }}
                type="text"
                value={selectedBrand?.Description}
              />
              {themeData &&
                <InputContainer
                  label="Theme"
                  labelField="Text"
                  list={themeData}
                  onValueChange={(event: any, newValue: any) => {
                    onFormItemBrandChange({
                      value: event.target.value,
                      field: 'Theme',
                      idx: index
                    });
                  }}
                  optionName='Choose Theme'
                  type="select"
                  value={selectedBrand?.Theme}
                  valueField="Value"
                />

              }



            </div>
          }
          expandedPanel="BrandMappings"
          headerTitle="Brand Mappings"
        />
      )

      )}
      {_.map(brandMappings, (selectedBrand: any, index: any) => (

        <AccordionContainer child={
          <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

            <InputContainer
              label="Level"
              labelField="Text"
              list={policyOwnerType}
              isDisabled={selectedBrand?.Id && selectedBrand?.OwnerLevelId}
              onValueChange={(event: any, newValue: any) => {
                onFormItemBrandChange({
                  value: event.target.value,
                  field: 'OwnerLevelId',
                  idx: index
                });
              }}
              optionName='Choose Level'
              type="select"
              value={selectedBrand?.OwnerLevelId}
              valueField="Value"
            />
            <InputContainer
              label="Account Type"
              labelField="Name"
              isLoading={accountTypesListLoading}
              list={accountTypesList}
              isDisabled={selectedBrand?.Id && selectedBrand?.OwnerTypeId}
              onValueChange={(event: any, newValue: any) => {
                onFormItemBrandChange({
                  value: event.target.value,
                  field: 'OwnerTypeId',
                  idx: index
                });
              }}
              optionName='Choose Account Type'
              type="select"
              value={selectedBrand?.OwnerTypeId}
              valueField="Id"
            />
            <InputContainer
              label="Account Name"
              labelField="Name"
              isLoading={accountListLoading}
              list={accountsList}
              isDisabled={selectedBrand?.Id && selectedBrand?.OwnerAccountId}
              onValueChange={(event: any, newValue: any) => {
                onFormItemBrandChange({
                  value: event.target.value,
                  field: 'OwnerAccountId',
                  idx: index
                });
              }}
              optionName='Choose Account Name'
              type="select"
              value={selectedBrand?.OwnerAccountId}
              valueField="Id"
            />


          </div>
        }
          expandedPanel="BrandMappings"
          headerTitle="Levels"
        />
      )

      )}
    </>
  )
}

export default BrandMappingBasicInfoComponent;
